export const STABLE_COINS = ["USDT", "USDC"];
export const NO_MINING_COINS = ["USDT", "USDC", "ETH", "TON", "GRAM"];
